// extracted by mini-css-extract-plugin
export default {"header":"projectpage_header__TaUNr","title":"projectpage_title__J+-Y0","back-icon":"projectpage_back-icon__JDu1C"};